import React from "react";
import "./WhatsAppWidget.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Tooltip, Zoom } from "@mui/material";

const WhatsAppWidget = () => {
  // Replace with actual hostel office or warden number
  const phoneNumber = "919844398873";
  const message = encodeURIComponent("Hello Hostly Inn Support, I need assistance with...");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div className="whatsapp-widget">
      <Tooltip
        title="Chat with Support"
        placement="left"
        TransitionComponent={Zoom}
        arrow
      >
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-toggle-btn"
        >
          <WhatsAppIcon sx={{ fontSize: 32 }} />
          <span className="pulse"></span>
        </a>
      </Tooltip>
    </div>
  );
};

export default WhatsAppWidget;
